import React, { createContext, useCallback, useContext, useState } from "react";
import "./CarToast.css";

const ToastContext = createContext(null);

const TOAST_ICONS = {
  success: "✅",
  error: "🚫",
  warning: "🚗",
  info: "ℹ️",
};

const TOAST_TITLES = {
  success: "Success",
  error: "Error",
  warning: "Attention",
  info: "Notice",
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) =>
      prev.map((t) => (t.id === id ? { ...t, leaving: true } : t))
    );
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 300);
  }, []);

  const showToast = useCallback(
    ({ type = "info", title, message, duration = 4000 }) => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [
        ...prev,
        {
          id,
          type,
          title: title || TOAST_TITLES[type] || "Notice",
          message,
        },
      ]);

      if (duration > 0) {
        setTimeout(() => removeToast(id), duration);
      }

      return id;
    },
    [removeToast]
  );

  return (
    <ToastContext.Provider value={{ showToast, removeToast }}>
      {children}
      <div className="car-toast-container" aria-live="polite">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`car-toast ${toast.type} ${toast.leaving ? "leaving" : ""}`}
          >
            <div className="car-toast-icon">{TOAST_ICONS[toast.type] || "🚗"}</div>
            <div className="car-toast-content">
              <p className="car-toast-title">{toast.title}</p>
              <p className="car-toast-message">{toast.message}</p>
            </div>
            <button
              type="button"
              className="car-toast-close"
              onClick={() => removeToast(toast.id)}
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
